import React from "react";
import { LoadPhase, SkeletonCard } from "../../../components/ui";
import PageHeader from "../../../components/layout/PageHeader";

interface UserDetailSkeletonProps {
  phase: LoadPhase;
}

/**
 * The detail screen's own shape, while the account is fetched.
 *
 * Three blocks, one per card, at the heights the cards land at — so the record
 * arrives into a page that is already the shape it will keep rather than one
 * that jumps as each piece lands. One block per card and no more: drawing the
 * pills and facts inside them would read as a dozen things loading instead of
 * one page on its way.
 *
 * The header is drawn for real, without a title. It is the same header the
 * loaded screen has, so it does not move when the name arrives.
 */
const UserDetailSkeleton: React.FC<UserDetailSkeletonProps> = ({ phase }) => (
  <div className="h-full flex flex-col overflow-hidden px-4 py-5 sm:px-6 lg:px-8 3xl:px-12 3xl:py-8">
    <PageHeader title="" />

    <div className="mt-5 flex flex-col gap-4">
      <SkeletonCard phase={phase} className="h-[168px]" />
      <SkeletonCard phase={phase} className="h-[152px]" />
      <SkeletonCard phase={phase} className="h-[320px]" />
    </div>
  </div>
);

export default UserDetailSkeleton;
